exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".TotalHeader {\n  margin-bottom: 2rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Components/Main/TestWorkflow/Inventory/TotalHeader/TotalHeader.scss
// module id = 474
// module chunks = 0